import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';
import { UserTeams } from '@/shared/enums/user-teams.enum';

const ReferralsListContainer = React.lazy(
  () => import('../../containers/referrals-list/referrals-list.container')
);

const ReferralsAddContainer = React.lazy(
  () => import('../../containers/referrals-add/referrals-add.container')
);

const ReferralsDetailsContainer = React.lazy(
  () => import('../../containers/referrals-details/referrals-details.container')
);

const ReferralsEditContainer = React.lazy(
  () => import('../../containers/referrals-edit/referrals-edit.container')
);

export const ReferralsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER,
            UserRole.SALES_AGENT,
            UserRole.SALES_MANAGER,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER,
            UserRole.SALES_QUALITY_AGENT
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsDetailsContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.REFERRALS_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.OPERATION_MANAGER,
            UserRole.E_COMMERCE_REFERRAL,
            UserRole.E_COMMERCE_MANAGER,
            UserRole.FINANCE_OFFICER
          ]}
          permittedTeamsList={[UserTeams.DIGITAL, UserTeams.E_COMMERCE]}
          component={ReferralsEditContainer}
        />
      </React.Suspense>
    )
  }
];
